import { ServiceType } from '@/shared/api/protocol-ts/api/billing_new/dto_services_new_pb';
import { AssetType } from '@/shared/api/protocol-ts/model/dto_asset_pb';
import { StudyType } from '@/shared/api/protocol-ts/model/dto_study_pb';

import { CoinPayableOrderReportType } from './types';

export const GERMANY_COUNTRY_EXCEPTION = ['DE'];

export const LEGACY_EU_MAIN_UNMAPPED_COUNTRIES = ['BW', 'NA', 'ZA', 'ZW'];

export const USER_AGREEMENTS_LINKS = {
  termsAndConditions: 'https://diagnocat.com/legal-info/terms-conditions/',
  dataProcessingAddendumInGermany:
    'https://diagnocat.com/files/Data-Processing-Addendum-Diagnocat.pdf',
  privacyPolicyInGermany:
    'https://diagnocat.com/files/privacy-policy-diagnocat.pdf',
  dataProcessingAddendumInEnglish:
    'https://diagnocat.com/files/Data-Processing-Addendum-Diagnocat.pdf',
  privacyPolicyInEnglish:
    'https://diagnocat.com/files/privacy-policy-diagnocat.pdf',
  agreementOfferInRussian:
    'https://diagnocat.ru/files/legal/dogovor-oferta.pdf',
  personalDataProcessingInRussian:
    'https://diagnocat.ru/files/legal/politika-obrabotki-pd-2.pdf',
};

export const SHOP_URL = 'https://diagnocat.ru/tariffs';

export type StudyToServiceMap = {
  [StudyType.StudyType_CBCT]: ServiceType.ServiceType_Order_CBCT_GP_Analysis;
  [StudyType.StudyType_IntraoralXRay]: ServiceType.ServiceType_Order_IOXRay_GP_Analysis;
  [StudyType.StudyType_PanoramicXRay]: ServiceType.ServiceType_Order_Panoramic_GP_Analysis;
  [StudyType.StudyType_IOS_Meshes]: ServiceType.ServiceType_Order_CBCT_STL_Analysis;
  [StudyType.StudyType_DentalPhoto]: ServiceType.ServiceType_Order_DentalPhoto_GP_Analysis;
};

export const STUDY_TO_SERVICES_MAP: StudyToServiceMap = {
  [StudyType.StudyType_CBCT]: ServiceType.ServiceType_Order_CBCT_GP_Analysis,
  [StudyType.StudyType_IntraoralXRay]:
    ServiceType.ServiceType_Order_IOXRay_GP_Analysis,
  [StudyType.StudyType_PanoramicXRay]:
    ServiceType.ServiceType_Order_Panoramic_GP_Analysis,
  [StudyType.StudyType_IOS_Meshes]:
    ServiceType.ServiceType_Order_CBCT_STL_Analysis,
  [StudyType.StudyType_DentalPhoto]:
    ServiceType.ServiceType_Order_DentalPhoto_GP_Analysis,
};

export type AssetToServiceOrderReportMap = {
  [AssetType.AssetType_Study_CBCT]: ServiceType.ServiceType_Order_CBCT_GP_Analysis;
  [AssetType.AssetType_Study_IntraoralXRay]: ServiceType.ServiceType_Order_IOXRay_GP_Analysis;
  [AssetType.AssetType_Study_PanoramicXRay]: ServiceType.ServiceType_Order_Panoramic_GP_Analysis;
};

export const ASSET_TO_SERVICE_ORDER_REPORT_MAP: AssetToServiceOrderReportMap = {
  [AssetType.AssetType_Study_CBCT]:
    ServiceType.ServiceType_Order_CBCT_GP_Analysis,
  [AssetType.AssetType_Study_IntraoralXRay]:
    ServiceType.ServiceType_Order_IOXRay_GP_Analysis,
  [AssetType.AssetType_Study_PanoramicXRay]:
    ServiceType.ServiceType_Order_Panoramic_GP_Analysis,
};

export const SUBSCRIPTION_EFFECT_TYPES = {
  ADD: 'SubscriptionAdd',
  RENEW: 'SubscriptionRenew',
  AUTO_RENEWAL: 'SubscriptionSetAutoRenewal',
} as const;

export const PACKAGE_EFFECT_TYPES = {
  ADD: 'PackageAdd',
} as const;

export const EXPIRY_HINT_MONTHS = 3;

export const ORDER_REPORT_TYPE_SERVICE_TYPES: Record<
  CoinPayableOrderReportType,
  readonly ServiceType[]
> = {
  CBCT: [ServiceType.ServiceType_Order_CBCT_GP_Analysis],
  Pano: [ServiceType.ServiceType_Order_Panoramic_GP_Analysis],
  IOXRay: [ServiceType.ServiceType_Order_IOXRay_GP_Analysis],
  '3DStudio': [
    ServiceType.ServiceType_Order_CBCT_STL_Analysis,
    ServiceType.ServiceType_Order_CBCT_IOS_Superimposition_Analysis,
  ],
  ImplantStudio: [ServiceType.ServiceType_Order_ImplantStudio_Analysis],
  OrthoStudio: [
    ServiceType.ServiceType_Order_OrthoStudio_Analysis,
    ServiceType.ServiceType_Order_CBCT_Orthodontic_Analysis,
  ],
  IOSSegmentation: [ServiceType.ServiceType_Order_IOS_Segmentation_Analysis],
  Transcriptor: [ServiceType.ServiceType_Order_Transcriptor],
};
